module.exports = __webpack_public_path__ + "e9618d6a93755fde9ab68f3eb62e9d2d.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Modules/4/Assets/vegeserve.png
// module id = 1336
// module chunks = 0